export default Object.freeze({
  None: 0,
  Value: 1,
  DisplayText: 2,
});
